export function toFixedNumber(number: number, precision: number): number {
    const ratio = Math.pow(10, precision);
    return Math.round(number * ratio) / ratio;
}

export function isNumber(x?: number): boolean {
    return typeof x === "number" && !isNaN(x);
}
